/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import InputMask from "../../../../components/hookForms/inputMask";
import InputNumber from "../../../../components/hookForms/inputNumber";
import messages from "../../../../utils/messages";
import serviceFaturaInstalacao from "../../../../services/serviceFaturaInstalacao";
import { toast } from "react-toastify";
import { useAuth } from "../../../../context/global";
import { useForm } from "react-hook-form";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
    data: {
        open: boolean;
        id: string;
        energiaInjetada: string;
        energiaCompensada: string;
        consumo: string;
        saldoConsolidadoAnterior: string;
        saldoConsolidadoAtual: string;
        saldoConsolidadoDiferenca: string;
        disponibilidadeKWH: string;
        valorFaturaConcessionaria: string;
        dataVencimentoConcessionaria: string;
        energiaPrevista: string;
        saldoAlsolAnterior: string;
        saldoConcessionariaAnterior: string;
        saldoOutrosAnterior: string;
        bonificacaoDinheiro: string;
        bonificacaoKWH: string;
        acrescimoDinheiro: string;
        acrescimoKWH: string;
        saldoAlsolAtual: string;
        saldoConcessionariaAtual: string;
        saldoOutrosAtual: string;
        saldoAlsolDiferenca: string;
        saldoConcessionariaDiferenca: string;
        saldoOutrosDiferenca: string;
        creditosFaturados: string;
        kwhTotal: string;
        injecaoTotal: string;
        tarifaCobrada: string;
        precoTotal: string;
        totalPagar: string;
        numeroInstalacao: string;
        nomeUsina: string;
        injecaoAlsol: string;
        creditosMes: string;
    };
}

export default function DialogEdit({ open, onClose, data, onSuccess }: IDialogProps) {
    const { handleGetDataUser } = useAuth();
    const [isDisable, setDisable] = useState(false);
    const [injecaoTotalFaturar, setInjecaoTotalFaturar] = useState("");
    const [saldoFaturar, setSaldoFaturar] = useState(0);
    const [injecaoAlsol, setInjecaoAlsol] = useState(0);
    const [tarifaCobrada, setTarifaCobrada] = useState(0);
    const user = handleGetDataUser();
    var formato = { minimumFractionDigits: 2, style: "currency", currency: "BRL" };

    const isAdmin = user.perfil === "Admin";
    const isMaster = user.perfil === "Master";

    // Receber o valor padrão
    // Atualizar estado conforme os valores forem alterados
    // Setar valor

    const {
        control,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: {
            energiaInjetada: "",
            energiaCompensada: "",
            consumo: "",
            saldoConsolidadoAnterior: "",
            saldoConsolidadoAtual: "",
            saldoConsolidadoDiferenca: "",
            disponibilidadeKWH: "",
            valorFaturaConcessionaria: "",
            dataVencimentoConcessionaria: "",
            energiaPrevista: "",
            saldoAlsolAnterior: "",
            saldoConcessionariaAnterior: "",
            saldoOutrosAnterior: "",
            bonificacaoDinheiro: "",
            bonificacaoKWH: "",
            acrescimoDinheiro: "",
            acrescimoKWH: "",
            saldoAlsolAtual: "",
            saldoConcessionariaAtual: "",
            saldoOutrosAtual: "",
            saldoAlsolDiferenca: "",
            saldoConcessionariaDiferenca: "",
            saldoOutrosDiferenca: "",
            saldoNaoPagoFaturar: "",
            creditosFaturados: "",
            kwhTotal: "",
            injecaoFaturar: "",
            injecaoTotal: "",
            tarifaCobrada: "",
            precoTotal: "",
            totalPagar: "",
            creditosMes: "",
        },
    });

    const initialCalculates = () => {
        let kwhTotal =
            +data.acrescimoKWH.replaceAll(".", "").replaceAll(",", ".") +
            +data.bonificacaoKWH.replaceAll(".", "").replaceAll(",", ".");

        let saldoAlsolDiferenca = +data.saldoAlsolDiferenca.replaceAll(".", "").replaceAll(",", ".");

        let injecaoFaturar =
            +data.creditosFaturados.replaceAll(".", "").replaceAll(",", ".") -
            kwhTotal -
            (saldoAlsolDiferenca < 0 ? -saldoAlsolDiferenca : saldoAlsolDiferenca);

        let injecaoAlsol = +data.injecaoAlsol.replaceAll(".", "").replaceAll(",", ".");

        let precoTotal =
            +data.acrescimoDinheiro.replaceAll(".", "").replaceAll(",", ".") +
            +data.bonificacaoDinheiro.replaceAll(".", "").replaceAll(",", ".");

        let tarifaCobrada = +data.tarifaCobrada.replaceAll(".", "").replaceAll(",", ".");

        let totalPagar = +data.creditosFaturados.replaceAll(".", "").replaceAll(",", ".") * tarifaCobrada + precoTotal;
        return {
            injecaoFaturar,
            injecaoAlsol,
            kwhTotal,
            precoTotal,
            totalPagar,
            saldoAlsolDiferenca,
            tarifaCobrada,
        };
    };

    const onBlur = (event: any) => {
        const res = initialCalculates();
        const { name, value } = event.target;
        const formattedValue = Number(value.replaceAll(".", "").replaceAll(",", "."));

        if (name === "tarifaCobrada") {
            setInjecaoTotalFaturar(
                ((injecaoAlsol - saldoFaturar + res.kwhTotal) * formattedValue + res.precoTotal).toLocaleString(
                    "pt-BR",
                    formato
                )
            );

            setTarifaCobrada(formattedValue);
        }

        if (name === "saldoAlsolDiferenca") {
            setValue("creditosMes", (injecaoAlsol - formattedValue).toLocaleString("pt-BR", formato));

            setValue("saldoNaoPagoFaturar", Math.abs(formattedValue).toLocaleString("pt-BR", formato));

            setValue(
                "creditosFaturados",
                (injecaoAlsol - formattedValue + res.kwhTotal).toLocaleString("pt-BR", formato)
            );

            setInjecaoTotalFaturar(
                ((injecaoAlsol - formattedValue + res.kwhTotal) * tarifaCobrada + res.precoTotal).toLocaleString(
                    "pt-BR",
                    formato
                )
            );

            setSaldoFaturar(formattedValue);

            if (formattedValue >= 0) {
                setValue("saldoNaoPagoFaturar", "0");
                setSaldoFaturar(formattedValue);
            }
        }

        if (name === "injecaoAlsol") {
            setValue("creditosMes", (formattedValue - saldoFaturar).toLocaleString("pt-BR", formato));
            setValue(
                "creditosFaturados",
                (formattedValue - saldoFaturar + res.kwhTotal).toLocaleString("pt-BR", formato)
            );

            setInjecaoTotalFaturar(
                ((formattedValue - saldoFaturar + res.kwhTotal) * tarifaCobrada + res.precoTotal).toLocaleString(
                    "pt-BR",
                    formato
                )
            );

            setInjecaoAlsol(formattedValue);
        }
    };

    useEffect(() => {
        setValue("totalPagar", injecaoTotalFaturar);
    }, [injecaoTotalFaturar]);

    useEffect(() => {
        if (data) {
            reset(data);
            const res = initialCalculates();

            setInjecaoAlsol(res.injecaoAlsol);
            setTarifaCobrada(res.tarifaCobrada);

            if (res.kwhTotal || res.kwhTotal === 0) {
                setValue("kwhTotal", res.kwhTotal.toLocaleString("pt-BR", formato));
            }

            if (res.precoTotal || res.precoTotal === 0) {
                setValue("precoTotal", res.precoTotal.toLocaleString("pt-BR", formato));
            }

            if (res.saldoAlsolDiferenca < 0) {
                setValue("saldoNaoPagoFaturar", res.saldoAlsolDiferenca.toLocaleString("pt-BR", formato));
                setSaldoFaturar(res.saldoAlsolDiferenca);
            } else {
                setValue("saldoNaoPagoFaturar", "0");
                setSaldoFaturar(res.saldoAlsolDiferenca);
            }

            if (res.totalPagar || res.totalPagar === 0) {
                setValue("totalPagar", (+res.totalPagar.toFixed(3)).toLocaleString("pt-BR", formato));
            }
        }
    }, [data]);

    const onSubmit = (values: any) => {
        setDisable(true);

        const updateValues = {
            ...values,
            faturaInstalacaoID: data.id,
            saldoConsolidadoAnterior: values.saldoConsolidadoAnterior
                ? Number(values.saldoConsolidadoAnterior.replaceAll(".", "").replaceAll(",", "."))
                : 0,
            saldoConsolidadoAtual: values.saldoConsolidadoAtual
                ? Number(values.saldoConsolidadoAtual.replaceAll(".", "").replaceAll(",", "."))
                : 0,
            saldoConsolidadoDiferenca: values.saldoConsolidadoDiferenca
                ? Number(values.saldoConsolidadoDiferenca.replaceAll(".", "").replaceAll(",", "."))
                : 0,
            disponibilidadeKWH: values.disponibilidadeKWH
                ? Number(values.disponibilidadeKWH.replaceAll(".", "").replaceAll(",", "."))
                : 0,
            energiaPrevista: values.energiaPrevista
                ? Number(values.energiaPrevista.replaceAll(".", "").replaceAll(",", "."))
                : 0,
            saldoAlsolDiferenca: values.saldoAlsolDiferenca
                ? Number(values.saldoAlsolDiferenca.replaceAll(".", "").replaceAll(",", "."))
                : 0,
            saldoConcessionariaDiferenca: values.saldoConcessionariaDiferenca
                ? Number(values.saldoConcessionariaDiferenca.replaceAll(".", "").replaceAll(",", "."))
                : 0,
            saldoOutrosDiferenca: values.saldoOutrosDiferenca
                ? Number(values.saldoOutrosDiferenca.replaceAll(".", "").replaceAll(",", "."))
                : 0,
            injecaoAlsol: values.injecaoAlsol
                ? Number(values.injecaoAlsol.replaceAll(".", "").replaceAll(",", "."))
                : 0,
            creditosFaturados: values.creditosFaturados
                ? Number(values.creditosFaturados.replaceAll(".", "").replaceAll(",", ".").replaceAll("R$ ", ""))
                : 0,
            tarifaCobrada: values.tarifaCobrada
                ? Number(values.tarifaCobrada.replaceAll(".", "").replaceAll(",", "."))
                : 0,
            valorFatura: values.totalPagar
                ? Number(values.totalPagar.replaceAll(".", "").replaceAll(",", ".").replaceAll("R$ ", ""))
                : 0,
        };

        serviceFaturaInstalacao
            .update(updateValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose(true);
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    Editar Fatura
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form>
                    <DialogContent dividers>
                        <Box>
                            <Typography variant="subtitle2">
                                Fatura: {data.id} Instalação: {data.numeroInstalacao} Usina: {data.nomeUsina}{" "}
                            </Typography>
                            <Typography variant="subtitle1">Dados Fatura</Typography>
                            <Grid container spacing={1}>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="energiaInjetada"
                                        name="energiaInjetada"
                                        label="Qtd Injetada (kWh)"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        disabled
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="energiaCompensada"
                                        name="energiaCompensada"
                                        label="Qtd Compensada (kWh)"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        disabled
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="consumo"
                                        name="consumo"
                                        label="Consumo"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        disabled
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="saldoConsolidadoAnterior"
                                        name="saldoConsolidadoAnterior"
                                        label="Saldo Anterior (kWh)"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="saldoConsolidadoAtual"
                                        name="saldoConsolidadoAtual"
                                        label="Saldo Atual (kWh)"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="saldoConsolidadoDiferenca"
                                        name="saldoConsolidadoDiferenca"
                                        label="Diferença de Saldo"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        allowNegative
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="disponibilidadeKWH"
                                        name="disponibilidadeKWH"
                                        label="Disponibilidade"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="valorFaturaConcessionaria"
                                        name="valorFaturaConcessionaria"
                                        label="Valor da Fatura (R$)"
                                        control={control}
                                        error={errors}
                                        decimalScale={2}
                                        maxLength={12}
                                        disabled
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <InputMask
                                        id="dataVencimentoConcessionaria"
                                        name="dataVencimentoConcessionaria"
                                        label="Vencimento da Fatura"
                                        mask="99/99/9999"
                                        control={control}
                                        error={errors}
                                        disabled
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        <Box>
                            <Typography variant="subtitle1">Previsto</Typography>
                            <Grid container spacing={1}>
                                <Grid item md={12}>
                                    <InputNumber
                                        id="energiaPrevista"
                                        name="energiaPrevista"
                                        label="Quantidade Prevista"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        <Box>
                            <Typography variant="subtitle1">Créditos Correntes</Typography>
                            <Grid container spacing={1}>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="saldoAlsolAnterior"
                                        name="saldoAlsolAnterior"
                                        label="Não pago"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        disabled
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="saldoConcessionariaAnterior"
                                        name="saldoConcessionariaAnterior"
                                        label="Concessionária"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        disabled
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="saldoOutrosAnterior"
                                        name="saldoOutrosAnterior"
                                        label="Outros"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        disabled
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        <Box>
                            <Typography variant="subtitle1">Créditos Adicionados/Reduzidos</Typography>
                            <Grid container spacing={1}>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="saldoAlsolDiferenca"
                                        name="saldoAlsolDiferenca"
                                        label="Não pago"
                                        onBlur={onBlur}
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        allowNegative
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="saldoConcessionariaDiferenca"
                                        name="saldoConcessionariaDiferenca"
                                        label="Concessionária"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        allowNegative
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <InputNumber
                                        id="saldoOutrosDiferenca"
                                        name="saldoOutrosDiferenca"
                                        label="Outros"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        allowNegative
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        <Box>
                            <Typography variant="subtitle1">Lançamentos Manuais</Typography>
                            <Box sx={{ mt: 2 }}>
                                <Typography variant="subtitle2">DEDUÇÕES</Typography>
                                <Grid container spacing={1}>
                                    <Grid item md={6}>
                                        <InputNumber
                                            id="bonificacaoDinheiro"
                                            name="bonificacaoDinheiro"
                                            label="Valor (R$)"
                                            control={control}
                                            error={errors}
                                            decimalScale={2}
                                            maxLength={12}
                                            disabled
                                            allowNegative
                                        />
                                    </Grid>
                                    <Grid item md={6}>
                                        <InputNumber
                                            id="bonificacaoKWH"
                                            name="bonificacaoKWH"
                                            label="kWh"
                                            control={control}
                                            error={errors}
                                            decimalScale={8}
                                            maxLength={18}
                                            disabled
                                            allowNegative
                                        />
                                    </Grid>
                                </Grid>
                                <Typography variant="subtitle2">ACRÉSCIMOS</Typography>
                                <Grid container spacing={1}>
                                    <Grid item md={6}>
                                        <InputNumber
                                            id="acrescimoDinheiro"
                                            name="acrescimoDinheiro"
                                            label="Valor (R$)"
                                            control={control}
                                            error={errors}
                                            decimalScale={2}
                                            maxLength={12}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item md={6}>
                                        <InputNumber
                                            id="acrescimoKWH"
                                            name="acrescimoKWH"
                                            label="kWh"
                                            control={control}
                                            error={errors}
                                            decimalScale={8}
                                            maxLength={18}
                                            disabled
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                        <Box>
                            <Typography variant="subtitle1">Valores a Faturar</Typography>

                            <Grid container spacing={1}>
                                <Grid item md={6}>
                                    <InputNumber
                                        id="injecaoAlsol"
                                        name="injecaoAlsol"
                                        label="Injeção no mês"
                                        control={control}
                                        error={errors}
                                        onBlur={onBlur}
                                        decimalScale={8}
                                        maxLength={18}
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <InputNumber
                                        id="creditosMes"
                                        name="creditosMes"
                                        label="Injeção a Faturar"
                                        control={control}
                                        error={errors}
                                        disabled
                                        decimalScale={8}
                                        maxLength={18}
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <InputNumber
                                        id="saldoNaoPagoFaturar"
                                        name="saldoNaoPagoFaturar"
                                        label="Saldo não pago a faturar (kWh)"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        disabled
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <InputNumber
                                        id="kwhTotal"
                                        name="kwhTotal"
                                        label="kWh Total de Lançamento Manual"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        allowNegative
                                        disabled
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <InputNumber
                                        id="creditosFaturados"
                                        name="creditosFaturados"
                                        label="Injeção Total a Faturar"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        disabled
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <InputNumber
                                        id="tarifaCobrada"
                                        name="tarifaCobrada"
                                        label="Valor kWh"
                                        onBlur={onBlur}
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        disabled={!isAdmin && !isMaster}
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <InputNumber
                                        id="precoTotal"
                                        name="precoTotal"
                                        label="Preço Total de lançamento Manual"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={18}
                                        allowNegative
                                        disabled
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <InputNumber
                                        id="totalPagar"
                                        name="totalPagar"
                                        label="Total a Pagar (R$)"
                                        control={control}
                                        error={errors}
                                        decimalScale={2}
                                        maxLength={12}
                                        disabled
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            id="cancelar"
                            onClick={onClose}
                            color="warning"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            id="salvar"
                            type="button"
                            onClick={handleSubmit(onSubmit)}
                            color="primary"
                            variant="contained"
                            disabled={isDisable}
                            style={{ width: "159px", height: "44px" }}
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}
